import { useState, useMemo } from "react";
import {
  useNavigate,
  useLocation,
  useLoaderData,
  Link,
} from "react-router-dom";
import {
  Button,
  message,
  Divider,
  Typography,
  Space,
  Row,
  Col,
} from "antd";
import { CopyOutlined } from "@ant-design/icons";
import copy from "copy-to-clipboard";
import { logout } from "../../request/login";
import useBalance from "../../hook/useBalance";
import useLocalStorage from "../../hook/useLocalStorage";
import InviteScroll from "../../components/InviteScroll"
import { queryInstance } from "../../request/server";
import { classNames, noop, getV } from "../../utils";
import styles from "./index.module.css";

const Header = () => {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const [logoutStatus, setLogoutStatus] = useState(false);
  const loadData: any = useLoaderData();
  const [tip] = useLocalStorage("header_tip");
  const [instanceInfo, setInstanceInfo] = useState<Record<
    string,
    number
  > | null>(null);
  const { user } = loadData || {};
  let hasHost = false;
  let hasPlatForm = false;
  if (user && Array.isArray(user.roles)) {
    user.roles.forEach((role: string) => {
      switch (role) {
        case "admin":
        case "super_admink":
          hasPlatForm = true;
          break;
        case "supplier":
          hasHost = true;
          break;
      }
    });
  }
  const navList = useMemo(() => {
    const result = [
      {
        route: "/home/gpu",
        to: "/home/gpu",
        title: "算力中心",
      },
      {
        route: "/home/control",
        to: "/home/control/main",
        title: "控制中心",
      },
      hasHost
        ? {
            route: "/home/host",
            to: "/home/host/main",
            title: "机主中心",
          }
        : null,
      hasPlatForm
        ? {
            route: "/home/platform",
            to: "/home/platform/main",
            title: "平台中心",
          }
        : null,
    ].filter((item) => item !== null);
    return result as {
      route: string;
      to: string;
      title: string;
    }[];
  }, [hasHost, hasPlatForm]);
  const isMain = !pathname || pathname === "/";
  const [data, updateBalance] = useBalance();
  const gv_balance = getV(data.data);
  return (
    <div
      className={classNames(
        styles.header,
        isMain && styles.header_no_border,
        !tip && styles.header_has_tip
      )}
    >
      {!tip ? (
        <div className={styles.header_tip}>
          🔥 GPU算力狂欢季｜超值性价比，就在这几天！
          <InviteScroll />
          {/* <CloseOutlined
            style={{ fontSize: 24, marginLeft: "auto", cursor: "pointer" }}
            onClick={() => {
              setTip("1");
            }}
          /> */}
        </div>
      ) : null}
      <div className={styles.wrapper}>
        <div className={styles.logo}>
          <img
            className={styles.logoImg}
            src="/logo192.png"
            alt=""
            onClick={() => {
              if (isMain) {
                return;
              }
              navigate("/");
            }}
          />
          <span
            className={styles.logoLabel}
            onClick={() => {
              if (isMain) {
                return;
              }
              navigate("/");
            }}
          >
            MyJuhe
          </span>
        </div>
        <div className={styles.group}>
          {navList.map((nav) => (
            <div
              key={nav.route}
              className={classNames(
                styles.item,
                pathname.indexOf(nav.route) > -1 && styles.active
              )}
              onClick={() => {
                pathname.indexOf(nav.route) === -1 && navigate(nav.to);
              }}
            >
              {nav.title}
            </div>
          ))}
          <div
            className={classNames(styles.item)}
            onClick={() =>
              window.open(window.location.origin + "/docs", "_blank")
            }
          >
            文档中心
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              fill="#b1bcc2"
              style={{ width: 12, height: 12, marginLeft: 6 }}
              aria-hidden="true"
              data-slot="icon"
            >
              <path
                fillRule="evenodd"
                d="M8.25 3.75H19.5a.75.75 0 0 1 .75.75v11.25a.75.75 0 0 1-1.5 0V6.31L5.03 20.03a.75.75 0 0 1-1.06-1.06L17.69 5.25H8.25a.75.75 0 0 1 0-1.5Z"
                clipRule="evenodd"
              ></path>
            </svg>
          </div>
          {user ? (
            // <Popover
            //   placement="bottom"
            //   mouseEnterDelay={0}
            //   mouseLeaveDelay={0}
            //   onOpenChange={(open) => {
            //     if (open) {
            //       updateBalance();
            //       queryInstance().then((data) => {
            //         if (data) {
            //           setInstanceInfo(data as Record<string, number>);
            //         }
            //       });
            //     }
            //   }}
            //   content={
            //     <div>
            //       <Space direction="vertical" size="middle">
            //         <Typography.Text>
            //           ID: {user.uuid}
            //           <CopyOutlined
            //             className="copy-id"
            //             onClick={() => {
            //               copy(user.uuid);
            //               message.success("复制成功");
            //             }}
            //           />
            //         </Typography.Text>
            //         <Row>
            //           <Col span={14}>
            //             <Typography.Text>
            //               账户余额: {gv_balance("balance")}
            //             </Typography.Text>
            //           </Col>
            //           <Col span={10} style={{ textAlign: "right" }}>
            //             <Link to="/recharge">
            //               <Button
            //                 size="small"
            //                 type="primary"
            //                 style={{ marginLeft: "auto" }}
            //               >
            //                 充值
            //               </Button>
            //             </Link>
            //           </Col>
            //         </Row>
            //         <Row>
            //           <Col span={24}>
            //             <Typography.Text>
            //               冻结金额: {gv_balance("frozen_balance")}
            //             </Typography.Text>
            //           </Col>
            //         </Row>
            //         <Link to="/home/control/instance">
            //           容器实例: {instanceInfo ? instanceInfo.all_num : 0}
            //         </Link>
            //       </Space>
            //       <Divider />
            //       <Button
            //         danger
            //         block
            //         disabled={logoutStatus}
            //         onClick={() => {
            //           setLogoutStatus(true);
            //           logout()
            //             .finally(() => {
            //               setLogoutStatus(false);
            //             })
            //             .then(() => {
            //               localStorage.removeItem("user");
            //               localStorage.removeItem("token");
            //               navigate("/login", { replace: true });
            //             })
            //             .catch(noop);
            //         }}
            //       >
            //         退出登录
            //       </Button>
            //     </div>
            //   }
            //   title={user.nickname}
            //   trigger="hover"
            // >
            //   <div className={styles.user}>{user.nickname}</div>
            // </Popover>
            <div
              className={styles.user}
              onMouseEnter={() => {
                updateBalance();
                queryInstance().then((data) => {
                  if (data) {
                    setInstanceInfo(data as Record<string, number>);
                  }
                });
              }}
            >
              <span>{user.nickname}</span>
              <div className={styles.popover}>
                <div className={styles.popoverArrow}></div>
                <div className={styles.popoverBox}>
                  <Space direction="vertical" size="middle">
                    <Typography.Text>
                      ID: {user.uuid}
                      <CopyOutlined
                        className="copy-id"
                        onClick={() => {
                          copy(user.uuid);
                          message.success("复制成功");
                        }}
                      />
                    </Typography.Text>
                    <Row>
                      <Col span={14}>
                        <Typography.Text>
                          账户余额: {gv_balance("balance")}
                        </Typography.Text>
                      </Col>
                      <Col span={10} style={{ textAlign: "right" }}>
                        <Link to="/recharge">
                          <Button
                            size="small"
                            type="primary"
                            style={{ marginLeft: "auto" }}
                          >
                            充值
                          </Button>
                        </Link>
                      </Col>
                    </Row>
                    <Row>
                      <Col span={24}>
                        <Typography.Text>
                          冻结金额: {gv_balance("frozen_balance")}
                        </Typography.Text>
                      </Col>
                    </Row>
                    <Link to="/home/control/instance">
                      实例数量: {instanceInfo ? instanceInfo.all_num : 0}
                    </Link>
                  </Space>
                  <Divider />
                  <Button
                    danger
                    block
                    disabled={logoutStatus}
                    onClick={() => {
                      setLogoutStatus(true);
                      logout()
                        .finally(() => {
                          setLogoutStatus(false);
                        })
                        .then(() => {
                          localStorage.removeItem("user");
                          localStorage.removeItem("token");
                          navigate("/login", { replace: true });
                        })
                        .catch(noop);
                    }}
                  >
                    退出登录
                  </Button>
                </div>
              </div>
            </div>
          ) : (
            <Button
              type="primary"
              size="large"
              style={{
                paddingLeft: 40,
                paddingRight: 40,
              }}
              onClick={() => navigate("/login", { replace: true })}
            >
              登录
            </Button>
          )}
          {/* <Space style={{ marginLeft: "auto" }}>
              <Link to="/login">登录</Link>
              <Divider type="vertical" />
              <Link to="/register">注册</Link>
            </Space> */}
        </div>
      </div>
    </div>
  );
};

export default Header;
